import { ReactElement, useContext } from 'react';
import cn from 'classnames';

import config from '../../config.json';
import styles from './Footer.module.scss';

import { Logo } from '../Logo/Logo';
import { ContactItem } from '../ContactItem/ContactItem';
import { AppContext } from '../../context/AppContext';

interface FooterProps {
    className?: string;
    disableLogoLink?: boolean;
}

export const Footer = ({ className, disableLogoLink }: FooterProps): ReactElement | null => {
    const ctx = useContext(AppContext);
    return (
        <footer className={cn(styles.wrapper, className)} id="page-footer" data-test="footer">
            <Logo className={styles.logo} withLink={!disableLogoLink} data-test="footerLogo" />
            <div className={styles.links} data-test="footerLinks">
                <span className={styles.copyright} data-test="footerCodeOrCopyright">
                    {ctx.formResult.ExternalId
                        ? 'Kód nabídky: ' + ctx.formResult.ExternalId?.substring(0, 8)
                        : new Date().getFullYear() + ' © Simplea'}
                </span>
                <ContactItem
                    className={styles.linkItem}
                    value={config.SIMPLEA_EMAIL}
                    type="email"
                    data-test="contactItem"
                />
            </div>
        </footer>
    );
};
